export default __webpack_public_path__ + "static/media/i-external.de0af43e.svg";